<!-- @format -->

@if(isPlp3Template()){
    <div
        class="checkbox-container no-unique-height hmf-position-relative hmf-pr-xxs"
        [class]="showMore() ? 'view-less' : 'view-more'">
        @for (
            filterOption of filteredList();
            track trackFilterName(filterOption)) {

            @if (
                !(attributeName() === GTGT_FILTER_NAME && filterOption?.value === 'N')
            ) {
                <a
                    id="{{
                        isMobile()
                            ? 'filter-mobile-' + filterOption.value
                            : 'filter-' + filterOption.value
                    }}"
                    class="plp3-filter hmf-mb-s hmf-body-m no-underline"
                    tabindex="{{ defaultOpen() ? 0 : -1 }}"
                    [href]="categoryDetails()?.[filterOption?.value]?.url">
                    <div class="hmf-display-flex hmf-align-items-center">
                        <span>
                            {{ categoryDetails()?.[filterOption?.value]?.name }}
                        </span>
                    </div>
                </a>
            }
        }
    </div>
} @else {
    <div
        class="checkbox-container no-unique-height hmf-position-relative hmf-pr-xxs hmf-mt-xxxs"
        [class]="showMore() ? 'view-less' : 'view-more'">
        @for (
            filterOption of filteredList();
            track trackFilterName(filterOption)) {

            @if (
                !(attributeName() === GTGT_FILTER_NAME && filterOption?.value === 'N')
            ) {
                <plp-components-filter-option
                    [class]="!allowCollapsing() && $last ? '' : 'hmf-mb-xxs'"
                    [filterOption]="filterOption"
                    [attributeName]="attributeName()"
                    [attributeIdentifier]="attributeIdentifier()"
                    [ariaLabel]="ariaLabels()[$index]"
                    [displayValue]="displayValues()[$index]"
                    [isMobile]="isMobile()"
                    [disabled]="disabled()"
                    [selectedOptions]="selectedOptions()"
                    [filterOptionType]="FilterOptionType.Selector"
                    (setSelectedFilter)="setSelectedFilter($event)"
                    (setSelectedFilterWithSpace)="setSelectedFilterWithSpace($event.event, $event.value)">
                </plp-components-filter-option>
            }
        }
    </div>
}
@if (allowCollapsing() && hasOverflow()) {
    <button
        hmf-action-text
        variant="secondary"
        class="hmf-px-0"
        (click)="toggleShowMore()">
        {{ showMore() ? 'View Less' : 'View More' }}
    </button>
}